import React, { useEffect, useState } from "react";

export default function VersionChecker() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    fetch("/version.json", { cache: "no-store" })
      .then((res) => res.json())
      .then((data) => {
        const deployedVersion = data.version;
        const storedVersion = localStorage.getItem("app_version");

        if (!storedVersion || storedVersion !== deployedVersion) {
          setShowPopup(true);
        }

        // Always update localStorage to latest version (whether popup shows or not)
        localStorage.setItem("app_version", deployedVersion);
      })
      .catch((err) => {
        console.error("Version check failed:", err);
      });
  }, []);

  if (!showPopup) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#fffbdd",
        padding: "12px",
        textAlign: "center",
        borderTop: "1px solid #e0c97f",
        zIndex: 9999,
      }}
    >
      🔄 A new version is available.&nbsp;
      <button
        onClick={() => (window.location.href = `/?reload=${Date.now()}`)}
        style={{
          backgroundColor: "#ffe58a",
          border: "none",
          padding: "8px 12px",
          borderRadius: "4px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Tap to Refresh
      </button>
    </div>
  );
}
